import { theme } from 'common/theme/app';
import Seo from 'components/seo';
import ContentPage from 'layouts/ContentPage';
import SiteLayout from 'layouts/SiteLayout';
import React from 'react';
import { PiClock, PiEnvelopeSimple } from 'react-icons/pi';
import styled from 'styled-components';

const ContactWrapper = styled.div`
  width: 100%;
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ContactInfo = styled.div`
  h3 {
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 600;
  }
  
  p {
    text-align: left;
    margin-bottom: 15px;
  }
  
  .info-item {
    display: flex;
    margin-bottom: 24px;
    align-items: flex-start;
  }
  
  .icon {
    margin-right: 15px;
    width: 42px;
    height: 42px;
    display: grid;
    place-items: center;
    flex: 0 0 42px;
    border-radius: 50%;
    color: ${theme.colors.headingColor};
    background: ${theme.colors.secondary};
    font-size: 21px;
  }
`;

const ContactForm = styled.div`
  form {
    display: flex;
    flex-direction: column;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
  }
  
  input, textarea {
    width: 100%;
    padding: 10px 15px;
    border: 1px solid ${theme.colors.outline};
    border-radius: 14px;
    background: ${theme.colors.surfaceRaised};
    font-size: 16px;
    transition: border-color 0.3s ease;
    
    &:focus {
      border-color: ${theme.colors.primary};
      outline: 3px solid ${theme.colors.focusRing};
      outline-offset: 2px;
    }
  }
  
  textarea {
    min-height: 150px;
    resize: vertical;
  }
  
  button {
    background-color: ${theme.colors.primary};
    color: white;
    border: none;
    padding: 12px 25px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 999px;
    cursor: pointer;
    align-self: flex-start;
    transition: background-color 0.3s ease;
    
    &:hover {
      background-color: ${theme.colors.primaryHover};
    }

    &:focus-visible {
      outline: 3px solid ${theme.colors.focusRing};
      outline-offset: 2px;
    }
  }
  
  .form-success {
    padding: 15px;
    background-color: #e7f7ed;
    color: #1e8449;
    border-radius: 12px;
    margin-bottom: 20px;
    display: none;
  }
`;

const Contact = () => {
  return (
    <SiteLayout>
        <Seo title="Contact Us | Furbuz Pet Care App" />
        <ContentPage
          title="Contact Us"
          description="Have questions, feedback, or need assistance with Furbuz? Our team is here to help."
          eyebrow="Support"
          width="1000px"
        >
          <ContactWrapper>
            <ContactGrid>
              <ContactInfo>
                <h3>Get In Touch</h3>
                <div className="info-item">
                  <span className="icon" aria-hidden="true">
                    <PiEnvelopeSimple />
                  </span>
                  <p>
                    <strong>Email us</strong><br />
                    <a href="mailto:support@furbuz.com">support@furbuz.com</a>
                  </p>
                </div>
                
                <div className="info-item">
                  <span className="icon" aria-hidden="true">
                    <PiClock />
                  </span>
                  <p>
                    <strong>Response time</strong><br />
                    We usually reply within 1–2 business days.
                  </p>
                </div>
              </ContactInfo>
              
              <ContactForm>
                <div className="form-success" id="form-success">
                  Thank you for your message! We'll get back to you as soon as possible.
                </div>
                
                <form 
                  name="contact" 
                  method="POST" 
                  data-netlify="true"
                  netlify-honeypot="bot-field"
                  onSubmit={() => {
                    document.getElementById('form-success').style.display = 'block';
                  }}
                >
                  <input type="hidden" name="form-name" value="contact" />
                  <p style={{ display: 'none' }}>
                    <label>Don't fill this out if you're human: <input name="bot-field" /></label>
                  </p>
                  
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input type="text" id="name" name="name" required />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input type="email" id="email" name="email" required />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="subject">Subject</label>
                    <input type="text" id="subject" name="subject" required />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea id="message" name="message" required></textarea>
                  </div>
                  
                  <button type="submit">Send Message</button>
                </form>
              </ContactForm>
            </ContactGrid>
          </ContactWrapper>
        </ContentPage>
    </SiteLayout>
  );
};

export default Contact; 